module.exports = __webpack_public_path__ + "img/UMCP.a7c9fe32.svg";